import { RECAPTCHA_ID } from '@constants';

export function ensureRecaptchaContainer(): void {
  if (typeof document === 'undefined') return;
  if (document.getElementById(RECAPTCHA_ID)) return;
  const container = document.createElement('div');
  container.id = RECAPTCHA_ID;
  document.body.appendChild(container);
}
